import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { DemandeEditionsPaieParSalariesDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeEditionsPaieParSalariesDto";
import { DemandeEditionsPaieDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeEditionsPaieDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalEditionBulletins extends Vue {
	public listNumerosSalaries: number[] = [];
	public listIdContrats: number[] = [];
	public typeEdition = "Simplifie";

	public dataReady = true;

	public startYear = 2018;
	public startMonth = 3;
	public endMonth = 3;
	public endYear = 2018;

	public Init(salariesFiltred: any[]): void {
    	this.dataReady = true;
		this.listNumerosSalaries = [];
		this.listIdContrats = [];
		this.typeEdition = "Simplifie";

		for (let i = 0; i < salariesFiltred.length; i++) {
			const salarie: any = salariesFiltred[i];

			if (salarie.selected) {
				if (salariesFiltred[i].Numero != undefined) {
					this.listNumerosSalaries.push(salariesFiltred[i].Numero as number);
				} else if (salariesFiltred[i].IdContrat != undefined) {
					salariesFiltred[i].IdContrat.forEach(idContrat => {
						this.listIdContrats.push(idContrat);
					});
				}
			}
		}

    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.PeriodeActive != undefined) {
    		this.startMonth = ParametresInstance.societeCourante.PeriodeActive.getUTCMonth() - 1;
    		this.startYear = ParametresInstance.societeCourante.PeriodeActive.getUTCFullYear();
    	} else {
    		this.startMonth = (new Date()).getUTCMonth() - 1;
    		this.startYear = (new Date()).getUTCFullYear();
    	}
    	this.endMonth = this.startMonth;
    	this.endYear = this.startYear;

    	this.editionEnCours = false;
	}

	public editionEnCours = false;

	public annuler(): void {
    	$("#modalEditionBulletins").modal("hide");
	}

	public lancerEdition(): void {
		if (this.editionEnCours) {
			return;
		}

		this.editionEnCours = true;
		this.dataReady = false;

		$("#modalEditionBulletins").modal("hide");

		NotificationServiceInstance.SendInformation("La demande d'édition a été prise en compte. Le document sera bientôt disponible");

		if (this.listNumerosSalaries.length > 0) {
			this.lancerEditionBySalarie();
		} else if (this.listIdContrats.length > 0) {
			this.lancerEditionByContrat();
		}
	}

	public lancerEditionByContrat(): void {
		const demande: DemandeEditionsPaieDto = {
			IdContrats: this.listIdContrats,
			AncienFormat: (this.typeEdition == "Ancien"),
			Detaille: (this.typeEdition == "Detaille"),
			AnneeDebut: this.startYear,
			AnneeFin: this.endYear,
			MoisDebut: this.startMonth + 1,
			MoisFin: this.endMonth + 1
		};

		ServicesFactoryInstance.CalculPaieService.getBulletinsPdf(demande, (r: Blob) => {
			this.recupererDocument(r);
		});
	}

	public lancerEditionBySalarie(): void {
		const demande: DemandeEditionsPaieParSalariesDto = {
			CodeSociete: ParametresInstance?.societeCourante?.Code,
    		NumerosSalaries: this.listNumerosSalaries,
    		AncienFormat: (this.typeEdition == "Ancien"),
    		Detaille: (this.typeEdition == "Detaille"),
    		AnneeDebut: this.startYear,
    		AnneeFin: this.endYear,
    		MoisDebut: this.startMonth + 1,
    		MoisFin: this.endMonth + 1
    	};

		ServicesFactoryInstance.CalculPaieService.getBulletinsPdfParSalaries(demande, (r: Blob) => {
			this.recupererDocument(r);
    	});
	}

	public recupererDocument(blob: Blob) {
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(blob, "bulletins de salaire.pdf");
			this.dataReady = true;
		} else {
			this.dataReady = true;

			const link = document.createElement("a");
			document.body.appendChild(link);

			link.href = window.URL.createObjectURL(blob);
			link.download = "bulletins de salaire.pdf";
			link.click();

			NotificationServiceInstance.SendSuccess("L'édition des bulletins s'est correctement déroulée !");
		}
	}
}




// WEBPACK FOOTER //
// ./src/components/calculDePaie/modalEditionBulletins/modalEditionBulletins.ts